import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ls from 'local-storage';
import moment from 'moment';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';

import DialogRootPanel from '../ai/dialog/DialogRootPanel';
import CharacterNameTool from '../ai/tools/CharacterNameTool';
import AuthForm from '../auth/tools/AuthForm';
import NiceModal from '../modals/NiceModal';
import DialogUserTemplate from '../templates/DialogUserTemplate';

function getUserCharacterName(currentUser) {
  if (currentUser && currentUser.characterName) {
    return currentUser?.characterName;
  }
  const lsCharacterName = ls.get('characterName');
  return lsCharacterName;
}

export default function DialogApp() {
  const { id, alias } = useParams();

  const [updT, setUpdT] = useState(0);
  const [authModal, setAuthModal] = useState(false);
  const [characterName, setCharacterName] = useState(undefined);

  const handleCloseAuthModal = () => setAuthModal(false);

  const { currentUser } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);

      return {
        currentUser: currentUser
      };
    }, [])
  );

  useEffect(() => {
    const characterName = getUserCharacterName(currentUser);
    setCharacterName(characterName);
  }, [currentUser]);

  const handleCharacterNameUpdate = useCallback(() => {
    const updatedCharacterName = getUserCharacterName(currentUser);
    setCharacterName(updatedCharacterName);
    setUpdT(moment().valueOf());
  }, [currentUser]);

  return (
    <DialogUserTemplate
      currentName={'dialog'}
      analyticsData={{
        scenario: alias,
        dialogId: id
      }}
    >
      <Wrapper
        id="dialog_panel_wrapper"
        key={`cc${updT}`}
      >
        {characterName && (
          <DialogRootPanel
            id={id}
            characterName={characterName}
            alias={alias}
            onNameChange={handleCharacterNameUpdate}
          />
        )}

        {!characterName && (
          <NiceModal canClose={false} onClose={() => { }}>
            <ModalInnerPlaceholder>
              <CharacterNameTool
                name={characterName}
                currentUser={currentUser}
                onAuthClick={() => setAuthModal(true)}
              />
            </ModalInnerPlaceholder>
          </NiceModal>
        )}

        {authModal && (
          <NiceModal onClose={handleCloseAuthModal}>
            <ModalInnerPlaceholder>
              <AuthForm onClose={handleCloseAuthModal} />
            </ModalInnerPlaceholder>
          </NiceModal>
        )}
      </Wrapper>
    </DialogUserTemplate>
  );
}

const ModalInnerPlaceholder = styled.div`
  width: 380px;
  box-sizing: border-box;
  padding: 20px;

  @media (max-width: 720px) {
    width: 100%;
  }
`;

const Wrapper = styled.div`
  max-height: calc(100vh - 116px);
  height: calc(100vh - 116px);
  overflow-y: hidden;
  position: relative;
  @media (max-width: 720px) {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100vh;
    height: 100dvh;
  }
`;
